import ApplicationAdapter from './application';

export default class extends ApplicationAdapter {
  pathForType() {
    return 'locations';
  }
}
